namespace Ir.Components.Workbook.Settings.FunnelSettings {
    interface IViewModel {
        config: WorkbookConfig;
        activeTabOrWidget: KnockoutObservable<ITabOrWidget>;
        activeTabItem: KnockoutObservable<SettingTabVM>;
        legendPositionParams: Ir.Components.Workbook.Settings.Items.LegendPositionSetting.ILegendPositionSettingParams;
        dxSelectBoxTypeConfig: DevExpress.ui.dxSelectBox.Properties;
        dxSelectBoxLabelPositionConfig: DevExpress.ui.dxSelectBox.Properties;
        itemConfig: FunnelConfig;
        metricParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        fieldParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        descriptionFieldParams: Ir.Components.Workbook.Settings.Items.FieldMetricSetting.IFieldMetricSettingParams;
        formatOptions: Ir.Components.Workbook.Settings.Items.MetricFormatSetting.IMetricFormatSettingParams;
        decimalPlacesOptions: Ir.Components.Workbook.Settings.Items.DecimalPlacesSetting.IParams;
        unitFormatOptions: Ir.Components.Workbook.Settings.Items.UnitFormatSetting.IUnitFormatSettingParams;
        labelShowPercentageCoonfig: DevExpress.ui.dxSwitch.Properties;
    }
    
    export function getViewModel(this: IViewModel, params: any) {
        let self = this;
        self.config = params.config as WorkbookConfig;
        self.activeTabOrWidget = params.activeTabOrWidget;
        self.activeTabItem = params.activeTabItem;
        this.itemConfig = this.activeTabOrWidget().itemConfig() as FunnelConfig;

        let currentWidget = ko.computed(() => {
            let widget = self.activeTabOrWidget()?.drilldownManager?.getActiveWidget();
            return widget instanceof FunnelWidget ? widget as FunnelWidget : null;
        })
        let currentConfig = ko.computed(() => {
            return currentWidget()?.itemConfig as FunnelConfig;
        });

        let saveFieldOrMetric = (newTabName: string = null, isMetric: boolean = false) => {
            let widget = currentWidget();
            let config = currentConfig();
            widget.saveSettings(function () {
                if (newTabName && !isMetric) {
                    widget.tabOrWidget.drilldownManager.getActiveDrillViewItem().tabName(newTabName);
                }

                if (isMetric) {
                    widget.tabOrWidget.drilldownManager.refresh();
                }
                else {
                    config.updateDrilldownListRemovingTemplateId(widget.tabOrWidget, () => {
                        widget.tabOrWidget.drilldownManager.refresh();
                    });
                }
            }, self.activeTabOrWidget().drilldownManager.activeDrilldownId);
        };

        this.metricParams = {
            label: "Metric",
            type: MappingPopoverTypeEnum.Metrics,
            id: ko.computed({
                read: function () {
                    return currentConfig()?.metric();
                },
                write: function (value: any) {
                    currentConfig().metric(value);
                }
            }) as any,
            onSelected(newValue, oldValue) {
                let config = currentConfig();
                config.metric(newValue.metricId);
                saveFieldOrMetric(null, true);
            }
        };
        this.fieldParams = {
            label: "Field",
            type: MappingPopoverTypeEnum.NonMetrics,
            id: ko.computed({
                read: function () {
                    return currentConfig()?.field();
                },
                write: function (value: any) {
                    currentConfig().field(value);
                }
            }) as any,
            autoGrouping: ko.computed({
                read: function () {
                    return currentConfig()?.fieldAutoGrouping();
                },
                write: function (value: any) {
                    currentConfig().fieldAutoGrouping(value);
                }
            }) as any,
            onSelected(newValue, oldValue) {
                let config = currentConfig();
                config.field(newValue.fieldId);
                config.fieldAutoGrouping(newValue.autoGrouping);
                saveFieldOrMetric(newValue.displayName);
            }
        };

        this.descriptionFieldParams = {
            label: "Description Field",
            type: MappingPopoverTypeEnum.NonMetricsNonDates,
            id: ko.computed({
                read: function () {
                    return currentConfig()?.descriptionField();
                },
                write: function (value: any) {
                    currentConfig().descriptionField(value);
                }
            }) as any,
            onSelected(newValue, oldValue) {
                currentConfig().descriptionField(newValue.fieldId);
                saveFieldOrMetric();
            }
        };

        this.legendPositionParams = { legendPosition: this.itemConfig.legendPosition };

        let types = [
            { value: FunnelTypeEnum.Funnel, text: "Funnel" },
            { value: FunnelTypeEnum.Pyramid, text: "Pyramid" },
        ];

        this.dxSelectBoxTypeConfig = {
            items: types,
            displayExpr: "text",
            valueExpr: "value",
            value: this.itemConfig.type,
            width: 75,
        };

        let positions = [
            { value: FunnelLabelPositionEnum.Outside, text: "Outside" },
            { value: FunnelLabelPositionEnum.Inside, text: "Inside" },
            { value: FunnelLabelPositionEnum.Columns, text: "Columns" },
        ];

        this.dxSelectBoxLabelPositionConfig = {
            items: positions,
            displayExpr: "text",
            valueExpr: "value",
            value: this.itemConfig.labelPosition,
            width: 85,
        };

        let formatOptionsComponent: Ir.Components.Workbook.Settings.Items.MetricFormatSetting.IMetricFormatSettingComponent = null;
        this.formatOptions = {
            value: this.itemConfig.format,
            onFiltering(items: Array<({ id: FieldFormatEnum, text: string })>) {
                if (self.itemConfig.labelShowPercentage()) {
                    return items.filter(x => x.id === FieldFormatEnum.Percentage);
                }

                return items.filter(x => x.id !== FieldFormatEnum.Percentage);;
            },
            getComponent(component: Ir.Components.Workbook.Settings.Items.MetricFormatSetting.IMetricFormatSettingComponent) {
                formatOptionsComponent = component;
            }
        };
        this.decimalPlacesOptions = {
            value: this.itemConfig.decimalPlaces
        };
        this.unitFormatOptions = {
            value: this.itemConfig.unitFormat
        };

        this.labelShowPercentageCoonfig = {
            value: this.itemConfig.labelShowPercentage as any,
            onValueChanged(e) {
                if (e.value) {
                    if (self.itemConfig.format() !== FieldFormatEnum.Percentage) {
                        self.itemConfig.format(FieldFormatEnum.Percentage);
                        formatOptionsComponent?.reload?.();
                    }
                }
                else {
                    if (self.itemConfig.format() === FieldFormatEnum.Percentage) {
                        self.itemConfig.format(FieldFormatEnum.None);
                        formatOptionsComponent?.reload?.();
                    }
                }
            }
        }
    }
}